import { SxProps } from '@mui/material';
import { black1, blue, blue3, green, white } from 'app/components/ThemeProvider/colors';
import { CSSProperties } from 'react';

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '12px 16px',
  background: 'transparent',
};
export const btnFilter: SxProps = {
  backgroundColor: 'white',
  width: 'fit-content',
  height: '48px',
  display: 'flex',
  gap: '10px',
  minWidth: '48px',
  p: '12px',
  '& .MuiSvgIcon-root': {
    width: '24px',
    height: '24px',
  },
};

export const outlinedInput: SxProps = {
  height: '48px',
  background: '#14191F0F',
  width: '290px',
  pl: '12px',

  '& fieldset': {
    border: 'none',
    background: 'transparent',
  },
};

export const inputStyle: CSSProperties = {
  background: 'transparent',
  fontSize: '16px',
  fontFamily: 'Yelo',
  color: black1,
  caretColor: 'rgba(20, 25, 31, 0.40)',
  lineHeight: 1,
  paddingLeft: 0,
};

export const accordionBox: SxProps = {
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
};

export const greenBtn: SxProps = {
  backgroundColor: 'rgba(36, 176, 126, 0.95)',
  color: 'white',
  gap: '12px',

  '&:hover': {
    background: green,
  },

  '& .MuiSvgIcon-root > path': {
    stroke: white,
  },
};

export const signBox: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
  mt: '32px',
};

export const sign: SxProps = {
  backgroundColor: blue,
  color: white,

  '&:hover': {
    backgroundColor: blue3,
  },
};

// export const customStyles = {
//   control: (base: any, state: any) => ({
//     ...base,
//     background: '#14191F0F',
//     fontFamily: 'Yelo',
//     color: 'rgba(20, 25, 31, 0.8)',
//     minHeight: '48px',
//     maxHeight: '48px',
//     height: '48px',
//     cursor: 'pointer',
//     borderRadius: '8px',
//     border: 'none',
//     width: '270px',
//     padding: '8px 16px',
//     fontWeight: '500',
//
//     boxShadow: state.isFocused ? null : null,
//     '&:hover': {
//       borderColor: 'transparent',
//     },
//   }),
//
//   container: (base: any) => ({
//     ...base,
//     height: '48px',
//   }),
//   menu: (base: any, state: any) => ({
//     ...base,
//
//     borderRadius: '8px',
//     boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
//     marginTop: 0,
//     padding: 0,
//   }),
//   menuList: (base: any) => ({
//     ...base,
//
//     padding: '16px 0',
//     fontFamily: 'Yelo',
//   }),
//
//   valueContainer: (base: any, state: any) => ({
//     ...base,
//     padding: 0,
//     margin: 0,
//     background: 'transparent',
//     fontWeight: state.getValue().length === 1 ? 500 : state.getValue() === 'All selected' ? 500 : 600,
//   }),
//
//   singleValue: (base: any) => ({
//     ...base,
//     margin: 0,
//   }),
//
//   multiValue: (base: any) => ({
//     ...base,
//     background: 'transparent',
//     width: '100%',
//     margin: 0,
//   }),
//
//   multiValueLabel: (base: any) => ({ ...base, padding: 0, paddingLeft: 0, fontSize: '16px', width: '96%' }),
//
//   placeholder: (base: any) => ({
//     ...base,
//     padding: 0,
//     margin: 0,
//     fontWeight: 500,
//     color: 'rgba(20, 25, 31, 0.8)',
//   }),
//
//   input: (base: any) => ({
//     ...base,
//     margin: 0,
//     padding: 0,
//     width: 0,
//     height: 0,
//   }),
//
//   dropdownIndicator: (base: any, state: any) => ({
//     ...base,
//     padding: 0,
//     // position: 'absolute',
//     // right: '-4px',
//     // bottom: '12px ',
//     transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
//     color: 'rgba(20, 25, 31, 0.8)',
//   }),
//
//   option: (base: any, state: any) => ({
//     ...base,
//     background: state.isSelected ? '#F3F4F6!important' : 'transparent',
//     paddingLeft: '19px',
//     color: black1,
//     display: 'flex',
//     gap: '12px',
//
//     '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
//   }),
// };

export const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    background: '#14191F0F',
    fontFamily: 'Yelo',
    color: black1,
    width: '270px',
    cursor: 'pointer',
    borderRadius: '8px',
    border: 'none',

    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      borderColor: 'transparent',
    },
  }),

  container: (base: any) => ({
    ...base,
  }),
  menu: (base: any, state: any) => ({
    ...base,
    width: '285px',
    borderRadius: '8px',
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
    marginTop: 0,
    padding: 0,
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    // padding: 0,
    height: '48px',
    padding: '12px 16px',
    // margin: 0,
    background: 'transparent',
    fontWeight: state.getValue().length === 1 ? 500 : state.getValue() === 'All selected' ? 500 : 600,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
  }),

  multiValue: (base: any) => ({
    ...base,
    background: 'transparent',
    width: '100%',
    margin: 0,
  }),

  multiValueLabel: (base: any) => ({ ...base, padding: 0, paddingLeft: 0, fontSize: '16px', width: '96%' }),

  placeholder: (base: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    fontWeight: 500,
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    color: black1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),
};
